import React, { useState, useEffect, useRef } from "react";
import "./Product.css";
import { useParams, useNavigate } from "react-router-dom";
import { track } from "../utils/tracking";
import { getProducts } from "../utils/productCache";
import CartModal from "../components/CartModal";

function Producto() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [producto, setProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);

  // ESTADOS DEL CARRITO
  const [cartItems, setCartItems] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);

  const hasTrackedView = useRef(false);

  // 1. Cargar carrito existente de localStorage al montar el componente
  useEffect(() => {
    const savedCart = localStorage.getItem("fiori_cart");
    if (savedCart) {
      try {
        setCartItems(JSON.parse(savedCart));
      } catch (e) {
        console.error("Error parseando carrito", e);
      }
    }
  }, []);

  // 2. Cargar datos del producto
  useEffect(() => {
    const loadProduct = async () => {
      try {
        const products = await getProducts();
        const prod = products.find((p) => String(p.product_id) === String(id));
        setProduct(prod);
      } catch (err) {
        console.error("Error cargando producto:", err);
      }
    };
    loadProduct();
  }, [id]);

  // 3. Tracking de vista
  useEffect(() => {
    if (producto && !hasTrackedView.current) {
      hasTrackedView.current = true;
      track("view_item", {
        product_id: id,
        product_name: producto.product_name || producto.name,
        price: producto.cost,
        category: producto.category || "unknown"
      });
    }
  }, [producto, id]);

  if (!producto) return <p className="not-found">Cargando producto...</p>;

  // LÓGICA DE ACCIONES
  const handleAction = (type) => {
    const total = producto.cost * quantity;
    const name = producto.product_name || producto.name;

    if (type === "cart") {
      // Crear array con la cantidad de productos seleccionada
      const newItems = Array(quantity).fill(producto);
      const updatedCart = [...cartItems, ...newItems];
      
      // Actualizar estado y persistir en localStorage inmediatamente
      setCartItems(updatedCart);
      localStorage.setItem("fiori_cart", JSON.stringify(updatedCart));

      track("add_to_cart", {
        product_id: id,
        product_name: name,
        price: producto.cost,
        quantity,
        total_value: total
      });

      // Abrir modal para confirmar
      setIsCartOpen(true);
    } 
    
    if (type === "buy") {
      track("purchase", {
        product_id: id,
        product_name: name,
        price: producto.cost,
        quantity,
        total_value: total,
        channel: "whatsapp"
      });

      const mensaje = `Hola, estoy interesado en el producto: ${name} (Cantidad: ${quantity})`;
      window.open(`https://wa.me/573046811554?text=${encodeURIComponent(mensaje)}`, "_blank");
    }
  };

  const removeFromCart = (index) => {
    const updatedCart = cartItems.filter((_, i) => i !== index);
    setCartItems(updatedCart);
    localStorage.setItem("fiori_cart", JSON.stringify(updatedCart));
  };

  return (
    <div className="product-page">
      {/* HEADER CON ICONO DE CARRITO */}
      <header className="product-header">
        <button className="back-btn" onClick={() => navigate(-1)}>
          ← Volver
        </button>
        
        <img src="/fiori_logo-Photoroom.png" alt="Fiori Logo" className="logo-img" onClick={() => navigate("/")} style={{cursor: 'pointer'}} />

        <div className="header-cart-section">
          <button className="header-cart-btn" onClick={() => setIsCartOpen(true)}>
            <span className="cart-icon">🛒</span>
            {cartItems.length > 0 && (
              <span className="header-cart-badge">{cartItems.length}</span>
            )}
          </button>
        </div>
      </header>

      <div className="product-container">
        <div className="gallery-section">
          <img src={producto.url} alt={producto.product_name} className="main-image" />
        </div>

        <div className="info-section">
          <h1>{producto.product_name || producto.name}</h1>
          <p className="price">{producto.cost}</p>
          <div className="divider"></div>
          
          <h3>Descripción</h3>
          <ul className="spec-list">
            {Array.isArray(producto.subproducts)
              ? producto.subproducts.map((item, i) => <li key={i}>{item}</li>)
              : <li>{producto.subproducts}</li>}
          </ul>

          <div className="divider"></div>

          <div className="quantity-section">
            <span>Cantidad:</span>
            <div className="quantity-box">
              <button onClick={() => quantity > 1 && setQuantity(quantity - 1)}>-</button>
              <span>{quantity}</span>
              <button onClick={() => setQuantity(quantity + 1)}>+</button>
            </div>
          </div>

          <div className="action-buttons">
            <button className="quote-btn cart-style" onClick={() => handleAction("cart")}>
              Enviar a Carrito
            </button>
            <button className="quote-btn buy-style" onClick={() => handleAction("buy")}>
              Contactar por Whatsapp
            </button>
          </div>
        </div>
      </div>

      <CartModal 
        isOpen={isCartOpen} 
        onClose={() => setIsCartOpen(false)} 
        cartItems={cartItems}
        onRemove={removeFromCart}
      />

      <footer className="footer">
        © 2026 FIORI floristería y eventos. Todos los derechos reservados.
      </footer>
    </div>
  );
}

export default Producto;